module.exports = __webpack_public_path__ + "u10.no2.d7fed745.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u10.no2.jpg
// module id = Mfpt
// module chunks = 0